import React from 'react';
import SidebarFooter from '../SidebarFooter';
import Button from '../../Button';
import styles from './SettingsContent.module.scss';

function SettingsFooter() {
  return (
    <SidebarFooter className={styles.footer}>
      <Button>Footer</Button>
      <Button>Button</Button>
    </SidebarFooter>
  );
}

SettingsFooter.propTypes = {

};

export default SettingsFooter;